import InformationModal from '../../../shared/components/modal-information';

export default class MentorSmsModal extends InformationModal {
  markModalAsRead() {
    $.ajax({
      url: this.$element.data('read-url'),
      type: 'PUT',
      // eslint-disable-next-line camelcase
      data: {user: {mentor_sms_modal_read_at: new Date()}},
      dataType: 'json',
    });
  }
}
